<template>
<div>
  <div
    class="layer2"
    v-for="(i, index) in elements"
    :key="index"
    :style="{
      top: i.top + 'mm',
      left: i.left + 'mm',
      width: i.width + 'mm',
      height: i.height + 'mm',
    }"
  >
    <div :style="{ color: i.content.color }">
      <div class="icon-box" v-if="i.content.icon">
        <div>
          <i
            v-if="
              i.style.constrain == 1 ||
              i.style.constrain == 4 ||
              i.style.constrain == 5
            "
            :class="i.content.icon"
            class="iconfont2"
            :style="{
              fontSize: i.iconSize + 'mm',
              position: 'absolute',
              left: i.iconCords.x - i.iconSize / 2 - (($store.state.artwork.type != 'blackjack') ? 2 : 0) + 'mm',
              top: i.iconCords.y - i.iconSize / 2 - (($store.state.artwork.type != 'blackjack') ? 2 : 0) + 'mm',
            }"
          ></i>
        </div>
      </div>
      <div class="text-box" v-if="i.content.textL1 || i.content.textL2" :key="rerenderKey">
        <div>
          <p
            :ref="'textL1_' + i.id"
            v-if="
              i.style.constrain == 2 ||
              i.style.constrain == 3 ||
              i.style.constrain == 4 ||
              i.style.constrain == 5
            "
            class=""
            :style="{
              fontFamily: fontType.toLowerCase().replaceAll(' ', ''),
              fontSize: i.fontSize + 'px',
              position: 'absolute',
              left: i.textCords.x - textL1width['textL1_' + i.id] - (($store.state.artwork.type != 'blackjack') ? 2 : 0) + 'mm',
              top: i.textCords.y - (($store.state.artwork.type != 'blackjack') ? 2 : 0) + 'mm',
              whiteSpace: 'pre',
              letterSpacing: letterSpacing,
              fontKerning: 'none'
            }"
          >{{i.content.textL1}}</p>
          <p
            :ref="'textL2_' + i.id"
            v-if="i.style.constrain == 3 || i.style.constrain == 5"
            class=""
            :style="{
              fontFamily: fontType.toLowerCase().replaceAll(' ', ''),
              fontSize: i.fontSize + 'px',
              position: 'absolute',
              left: i.textCords.x - textL2width['textL2_' + i.id] - (($store.state.artwork.type != 'blackjack') ? 2 : 0) + 'mm',
              top: i.textCords.y + i.textL2Offset - (($store.state.artwork.type != 'blackjack') ? 2 : 0) + 'mm',
              whiteSpace: 'pre',
              letterSpacing: letterSpacing,
            }"
          >{{i.content.textL2}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "EngravingElements",
  props: ["elements", "fontType"],
  data() {
    return {
      rerenderKey: 0,
      textL1width: {},
      textL2width: {},
      letterSpacing: '0.125px' // 0.25mm
    };
  },
  watch: {
    "$store.state.artwork": {
      deep: true,
      handler(newVal) {
        this.setTextWidths(newVal);
      },
    },
  },
  mounted() {
    this.setTextWidths(this.$store.state.artwork);
    this.forceRerender()
  },
  methods: {
    forceRerender() {
      this.rerenderKey += 1; // Vue will rebuild this part of the DOM
    },
    setTextWidths(val) {
        this.getTextWidths(val.content.entries())
        if (val.format != "single") {
            this.getTextWidths(val.rightContent.entries())
        }
        if (val.format == "triple") {
            this.getTextWidths(val.tripleRightContent.entries())
        }

    },
    getTextWidths(val) {
      for (let [index, v] of val) {
        if (typeof this.elements[index] == "undefined") continue;
        if (
          this.elements[index].alignment.textL1 == "P4" ||
          this.elements[index].alignment.textL1 == "P5" ||
          this.elements[index].alignment.textL1 == "P6"
        ) {
          if (v.textL1 && this.$refs['textL1_' + index].length > 0) {
            this.textL1width["textL1_" + index] =
              this.$refs['textL1_' + index][0].offsetWidth *
                0.264583;
          }
          if (v.textL2 && this.$refs['textL2_' + index].length > 0) {
            this.textL2width["textL2_" + index] =
              this.$refs['textL2_' + index][0].offsetWidth *
                0.264583;
          }
        } else if (this.elements[index].alignment.textL1 == "P7") {
          if (v.textL1 && this.$refs['textL1_' + index].length > 0) {
            this.textL1width["textL1_" + index] =
              (this.$refs['textL1_' + index][0].offsetWidth *
                0.264583) / 2;
          }
          if (v.textL2 && this.$refs['textL2_' + index].length > 0) {
            this.textL2width["textL2_" + index] =
              (this.$refs['textL2_' + index][0].offsetWidth *
                0.264583) / 2;
          }
        } else {
          this.textL1width["textL1_" + index] = 0;
          this.textL2width["textL2_" + index] = 0;
        }
      }
     
    },
  },
};
</script>

<style scoped>
</style>
